import { API } from '@/api';
import {
  DecoratedInvestor,
  UndecoratedCompany,
} from '@flemingmetrics/api-client';
import { renderProfileName } from '@/utils/strings';

export const classes = {
  paper: 'fixed top-8 rounded-2xl',
  wrapper: 'flex flex-col w-[90vw] max-w-[800px] min-w-[200px] min-h-0',
  inputBase: 'w-full text-2xl px-6 py-4 flex-0',
  clearButton: 'text-grey-7 hover:text-grey-8',
  resultsTitle: 'mx-4',
  resultsSection: 'mb-4 px-2',
  resultsList: 'flex-0 max-h-[40vh] overflow-auto',
  recentlyViewedHeader: 'w-full flex justify-end items-center px-6 py-0',
  recentList: 'pt-0 mt-0',
};

function buildCompanyOption(company: UndecoratedCompany) {
  return { label: company.name, value: company.id };
}

function buildInvestorOption(investor: DecoratedInvestor) {
  return { label: renderProfileName(investor.profile), value: investor.id };
}

export function getMatchingCompanies(
  query: string,
  companies: UndecoratedCompany[]
) {
  const search = query.toLowerCase().trim();
  if (search.length === 0) return companies.map(buildCompanyOption);
  return companies
    .filter((company) => company.name.toLowerCase().includes(search))
    .map(buildCompanyOption);
}

export function getMatchingInvestors(
  query: string,
  investors: DecoratedInvestor[]
) {
  const search = query.toLowerCase().trim();
  if (search.length === 0) return investors.map(buildInvestorOption);
  return investors
    .filter((investor) =>
      renderProfileName(investor.profile).toLowerCase().includes(search)
    )
    .map(buildInvestorOption);
}

export function getRecentCompanies(
  companyIds: number[],
  companies: UndecoratedCompany[]
) {
  return companyIds
    .map((id) => companies.find((company) => company.id === id)!)
    .map(buildCompanyOption);
}

export function getRecentInvestors(
  investorIds: number[],
  investors: DecoratedInvestor[]
) {
  return investorIds
    .map((id) => investors.find((investor) => investor.id === id)!)
    .map(buildInvestorOption);
}

export async function fetchSearchableData() {
  // NOTE: Just fetching a ton of companies/investors for now
  const [companies, investors] = await Promise.all([
    API.Companies.fetchCompanies({ pagination: { page: 1, pageSize: 250 } }),
    API.Investors.fetchInvestors({ pagination: { page: 1, pageSize: 250 } }),
  ]);
  return {
    companies: companies.results || [],
    investors: investors.results || [],
  };
}
